<template>
  <div style="padding-bottom:100px">
     <van-row style="text-align:center;margin-top:20px;">
      <img src="/images/1.png" style="width:40%"/>
    </van-row>
    <div style="margin-top:10px;text-align:left;width:100%;height:24px;color:black;font-size:1rem;line-height:1rem;" >
      <p><span class="title">产品编号：</span><span class="content">{{ baseInfo&&baseInfo.productId }}</span></p>
      <p><span class="title">产品品名：</span><span class="content">{{ baseInfo&&baseInfo.productName }}</span></p>
      <p><span class="title">产品品号：</span><span class="content">{{ baseInfo&&baseInfo.productNo }}</span></p>
      <p><span class="title">产品规格：</span><span class="content">{{ baseInfo&&baseInfo.spec }}</span></p>
      <template v-for="o in infos" >
        <p :key="o.name"><span class="title">{{o.name}}：</span><span class="content">{{o.val}}</span></p>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tabbar,TabbarItem,Icon,Button,Col,Toast, } from 'vant';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import {
  Row
} from "vant";
import  { getUrlParam } from '../../../util/urlUtil'
import { getBatchProductDetail } from '../../../api/wo'

Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Col);
Vue.use(VXETable)


export default {
  components: {
    Tabbar, 
    TabbarItem,
    Icon,
    Button,
    Col,
    Toast,
    Row
  },
  computed: {
  },
  data() {
    return {
        baseInfo:null,
        infos:[]
    };
  },
  async mounted(){
    this.infos = Vue.prototype.$productInfo;
    var batchId =  (new URL(window.location.href.toString().replace('/#/','/'))).searchParams.get('batchId'); 

    if(batchId){
      Toast.loading({
        message: '数据加载中...',
        forbidClick: true,
        duration:0
      });

      let resp = await getBatchProductDetail({
        batchId:batchId 
      });

      if(resp&&resp.code == 200){
        this.baseInfo = resp.data.main;

        this.baseInfo.productId = this.baseInfo.batchId|| batchId;
        this.baseInfo.productNo = this.baseInfo.productNo|| productNo;
      }

      Toast.clear();
    }
    else{
      alert('商品信息码异常!')
    }
  },
  methods: {
  }
};
</script>

<style scoped>

.baseInfo{
  margin-top:-10px;
    padding: 10px;
}
.hzImages{
  display: inline-block;
    background-repeat: round;
  background-image: url('/images/1.png');
}

.title{
  width:140px;
  margin:15px 10px 15px 20px;
  display:inline-block;
  text-align: right;
  font-weight: 700;
  font-size:16px;
}

.content{
  font-size:14px;
  color:dodgerblue;
  font-weight: 700;
}
</style>